//REGISTER
export const POST_FAKE_REGISTER = "/post-fake-register"

//LOGIN
export const POST_FAKE_LOGIN = "/post-fake-login"
export const POST_FAKE_JWT_LOGIN = "/post-jwt-login"
export const POST_FAKE_PASSWORD_FORGET = "/fake-forget-pwd"
export const POST_FAKE_JWT_PASSWORD_FORGET = "/jwt-forget-pwd"
export const SOCIAL_LOGIN = "/social-login"

//PROFILE
export const POST_EDIT_JWT_PROFILE = "/post-jwt-profile"
export const POST_EDIT_PROFILE = "/post-fake-profile"

// CUSTOMERS
export const GET_ALL_CUSTOMERS = "admin/customer/all"
export const GET_CUSTOMERS_LIST = "admin/customer/list"
export const GET_CUSTOMER_DETAILS = "admin/customer/details"
export const UPDATE_CUSTOMER_STATUS = "admin/customer/details/update-status"
export const UPDATE_CUSTOMER = "admin/customer/details/update"
export const DELETE_CUSTOMER = "admin/customer/delete"
export const CUSTOMER_LOYALTY_POINTS = "admin/common/loyalty-points/all"
export const ADD_LOYALTY_POINTS = "admin/common/loyalty-points/add"
export const REVOKE_LOYALTY_POINTS = "admin/common/loyalty-points/deduct"
export const PAYMENT_HISTORY = "admin/common/payment-history/all"
export const WALLET_HISTORY = "admin/common/wallet-transactions/all"
export const APP_VERSIONS = "admin/common/app/versions"

// AUTH USER
export const USER_DETAILS = "auth/regenerate-token"
export const USER_AUTH_DETAILS = "auth/details"
export const USER_DETAIL_UPDATE = "auth/details/update"
export const VALIDATE_UUID = "auth/validate-uuid"
export const NEW_USER_RESET_PASSWORD = "auth/new-user/reset-password"

// USERS
export const GET_ALL_USERS = "admin/user/all"
export const GET_USER_DETAILS = "admin/user/details"
export const ADD_ADMIN_USER = "admin/user/add"
export const UPDATE_ADMIN_USER = "admin/user/details/update"
export const UPDATE_ADMIN_USER_STATUS = "admin/user/details/update-status"
export const DELETE_ADMIN_USER = "admin/user/delete"
export const GET_BRANCH_LIST = "admin/branch/list"
export const GET_ROLES_LIST = "admin/roles/list"
export const UPDATE_USER_PASSWORD = "auth/details/update-password"
export const GET_USERS_LIST = "admin/user/list"

// BRANCH/LOCATIONS
export const GET_ALL_BRANCHES_LIST = "admin/branch/all"
export const GET_BRANCH_DETAILS = "admin/branch/details"
export const UPDATE_BRANCH_STATUS = "admin/branch/details/update-status"
export const DELETE_BRANCH = "admin/branch/delete"
export const ADD_BRANCH = "admin/branch/add"
export const UPDATE_BRANCH = "admin/branch/details/update"
export const UPDATE_MULTIPLES_BRANCH = "admin/branch/details/update-multiple"
export const COPY_BRANCH_SETTINGS = "admin/branch/details/copy-settings"
export const GENERATE_BRANCH_ID = "admin/branch/generate-id"
export const CLONE_BRANCH = "admin/branch/clone"

// BANNERS
export const GET_ALL_BANNERS_LIST = "admin/banner/all"
export const ADD_BANNER = "admin/banner/add"
export const GET_BANNER_DETAILS = "admin/banner/details"
export const UPDATE_BANNER = "admin/banner/details/update"
export const DELETE_BANNER = "admin/banner/delete"
export const UPDATE_BANNER_STATUS = "admin/banner/details/update-status"
// SLIDES
export const GET_SLIDE_DETAILS = "admin/slide/details"
export const UPDATE_SLIDE_STATUS = "admin/slide/details/update-status"
export const DELETE_SLIDE = "admin/slide/delete"
export const ADD_SLIDE = "admin/slide/add"
export const UPDATE_SLIDE = "admin/slide/details/update"

// CATEGORIES
export const GET_ALL_CATEGORIES_LIST = "admin/category/all"
export const GET_CATEGORY_DETAILS = "admin/category/details"
export const UPDATE_CATEGORY_STATUS = "admin/category/details/update-status"
export const DELETE_CATEGORY = "admin/category/delete"
export const ADD_CATEGORY = "admin/category/add"
export const UPDATE_CATEGORY = "admin/category/details/update"
// ITEMS
export const GET_ALL_ITEMS = "admin/item/all"
export const UPDATE_ITEM_STATUS = "admin/item/details/update-status"
export const ADD_ITEM = "admin/item/add"
export const GET_ITEM_DETAILS = "admin/item/details"
export const UPDATE_ITEM = "admin/item/details/update"
export const DELETE_ITEM = "admin/item/delete"
export const GET_ALL_ITEMS_DROPDOWN = "admin/item/list"
export const GET_CATEGORIES = "admin/category/list"
export const DELETE_MULTIPLE_ITEMS = "admin/item/delete-multiple"
export const UPDATE_MULTIPLE_ITEMS = "admin/item/details/update-multiple"
export const ADD_GALLERY_IMAGES = "admin/item/gallery-upload"
export const ADD_VIDEO = "admin/item/video-upload"
export const CLONE_ITEM = "admin/item/clone"
export const ENABLE_DISABLE_ITEM = "admin/item/details/enable-disable-item"
// COMBO
export const CALCULATE_COMBO_PRICE = "admin/item/calculate-price"

// MODIFIER GROUPS
export const GET_ALL_MODIFIER_GROUPS = "admin/modifier-group/all"
export const ADD_MODIFIER_GROUP = "admin/modifier-group/add"
export const GET_ALL_MODIFIER_GROUPS_LIST = "admin/modifier-group/list" //GET API
export const GET_MODIFIER_GROUP_DETAILS = "admin/modifier-group/details"
export const UPDATE_MODIFIER_GROUP = "admin/modifier-group/details/update"
export const UPDATE_MODIFIER_GROUP_STATUS =
  "admin/modifier-group/details/update-status"
export const DELETE_MODIFIER_GROUP = "admin/modifier-group/delete"

// MODIFIERS
export const GET_ALL_MODIFIER = "admin/modifier/all"
export const GET_ALL_MODIFIER_LIST = "admin/modifier/list"
export const UPDATE_MODIFIER_STATUS = "admin/modifier/details/update-status"
export const DELETE_MODIFIER = "admin/modifier/delete"
export const GET_MODIFIER_DETAILS = "admin/modifier/details"
export const ADD_MODIFIER = "admin/modifier/add"
export const UPDATE_MODIFIER = "admin/modifier/details/update"
export const ENABLE_DISABLE_MODIFIER =
  "admin/modifier/details/enable-disable-modifier"

// ITEM GROUPS
export const GET_ALL_ITEM_GROUPS = "admin/item-group/all"
export const GET_ITEM_GROUPS_LIST = "admin/item-group/list"
export const GET_ITEM_GROUP_DETAILS = "admin/item-group/details"
export const UPDATE_ITEM_GROUPS_STATUS =
  "admin/item-group/details/update-status"
export const DELETE_ITEM_GROUP = "admin/item-group/delete"
export const ADD_ITEM_GROUP = "admin/item-group/add"
export const UPDATE_ITEM_GROUP = "admin/item-group/details/update"

// COUNTRIES
export const GET_ALL_COUNTRIES = "admin/country/all"
export const UPDATE_COUNTRY_STATUS = "admin/country/details/update-status"
export const GET_ALL_COUNTRY_LIST = "admin/country/list"
export const GET_COUNTRY_DETAILS = "admin/country/details"
export const DELETE_COUNTRY = "admin/country/delete"
export const UPDATE_COUNTRY = "admin/country/update"
export const ADD_COUNTRY = "admin/country/add"

// REGION
export const GET_ALL_REGION_LIST = "admin/region/list"
export const GET_ALL_REGIONS = "admin/region/all"
export const GET_REGION_DETAILS = "admin/region/details"
export const UPDATE_REGION = "admin/region/details/update"
export const DELETE_REGION = "admin/region/delete"
export const UPDATE_REGION_STATUS = "admin/region/details/update-status"
export const ADD_REGION = "admin/region/add"

// CITY
export const GET_ALL_CITY_LIST = "admin/city/list"
export const GET_ALL_CITY = "admin/city/all"
export const GET_CITY_DETAILS = "admin/city/details"
export const UPDATE_CITY_DETAILS = "admin/city/details/update"
export const DELETE_CITY = "admin/city/delete"
export const UPDATE_CITY_STATUS = "admin/city/details/update-status"
export const ADD_CITY = "admin/city/add"

// COMMON
export const USER_ACTIVITY = "admin/common/user-activity"
export const USER_ACTIVITY_DETAILS = "admin/common/user-activity/details"
export const EXPORT_DATA = "admin/common/export-data"
export const BRANCH_COUNTRY = "admin/common/branch-country/list"

// ORDERS
export const GET_ALL_ORDERS = "admin/orders/all"
export const GET_ORDER_DETAILS = "admin/orders/details"
export const ORDER_STATUS_UPDATE = "admin/orders/update-status"

// TAX
export const GET_TAX_DETAILS = "admin/system-settings/taxes/details"
export const UPDATE_TAX_DETAILS = "admin/system-settings/taxes/details/update"

// DASHBOARD
export const DASHBOARD_KPI = "admin/common/dashboard-kpi"
export const DASHBOARD_KPI_ORDER = "admin/common/dashboard-kpi/orders"
export const DASHBOARD_KPI_BOOKING = "admin/common/dashboard-kpi/bookings"
export const DASHBOARD_KPI_RATINGS = "admin/common/dashboard-kpi/ratings"
export const WALLET_DASHBOARD = "admin/common/dashboard-kpi/wallet"

// LOGS
export const API_LOGS = "admin/common/api-logs/all"
export const API_LOG_DETAILS = "admin/common/api-logs/details"

// RATINGS
export const GET_ALL_RATINGS = "admin/ratings/all"
export const GET_ALL_QUESTIONS = "admin/ratings/questions/all"
export const GET_QUESTION_DETAILS = "admin/ratings/questions/details"
export const UPDATE_QUESTION_STATUS =
  "admin/ratings/questions/details/update-status"
export const DELETE_QUESTION = "admin/ratings/questions/delete"
export const ADD_QUESTION = "admin/ratings/questions/add"
export const UPDATE_QUESTION = "admin/ratings/questions/update"

export const GET_ALL_BRANCH_RATINGS = "admin/ratings/branch/feedbacks"
export const GET_BRANCH_RATINGS_DETAILS =
  "admin/ratings/branch/feedbacks/details"

// PROMOTIONS
export const GET_ALL_PROMOTIONS = "admin/coupon-promotion/all"
export const GET_ALL_PROMOTIONS_LISTS = "admin/coupon-promotion/list"
export const GET_PROMOTIONS_DETAILS = "admin/coupon-promotion/details"
export const ADD_PROMOTION = "admin/coupon-promotion/add"
export const UPDATE_PROMOTION = "admin/coupon-promotion/details/update"
export const UPDATE_PROMOTION_STATUS =
  "admin/coupon-promotion/details/update-status"
export const DELETE_PROMOTION = "admin/coupon-promotion/delete"
// COUPON GROUPS
export const GET_ALL_COUPON_GROUPS = "admin/coupon-group/all"
export const GET_ALL_COUPON_GROUPS_LIST = "admin/coupon-group/list"
export const GET_COUPON_GROUP_DETAILS = "admin/coupon-group/details"
export const ADD_COUPON_GROUP = "admin/coupon-group/add"
export const UPDATE_COUPON_GROUP = "admin/coupon-group/details/update"
export const UPDATE_COUPON_GROUP_STATUS =
  "admin/coupon-group/details/update-status"
export const DELETE_COUPON_GROUP = "admin/coupon-group/delete"
export const UPDATE_BULK_COUPON_GROUP = "admin/coupon/details/update-bulk"
// COUPON
export const GET_ALL_COUPONS = "admin/coupon/all"
export const GET_ALL_COUPONS_LIST = "admin/coupon/list"
export const GET_COUPON_DETAILS = "admin/coupon/details"
export const ADD_COUPON = "admin/coupon/add"
export const ADD_BULK_COUPONS = "admin/coupon/add-bulk"
export const UPDATE_COUPON = "admin/coupon/details/update"
export const UPDATE_COUPON_STATUS = "admin/coupon/details/update-status"
export const DELETE_COUPON = "admin/coupon/delete"
// COUPON USAGE
export const COUPON_USAGE = "admin/coupon-usage/all"
export const COUPON_USAGE_DETAILS = "admin/coupon-usage/details"

//GLOBAL SETTINGS
export const GLOBAL_SETTINGS = "admin/system-settings/global"
export const UPDATE_GLOBAL_SETTING = "admin/system-settings/global/update"
export const CLEAR_MENU_CACHE = "admin/system-settings/clearRedisCache"

// PUSH NOTIFICATION
export const GET_ALL_PUSH_NOTIFICATIONS = "admin/push-notification/all"
export const GET_PUSH_NOTIFICATION_DETAILS = "admin/push-notification/details"
export const UPDATE_PUSH_NOTIFICATION_STATUS =
  "admin/push-notification/details/update-status"
export const UPDATE_PUSH_NOTIFICATION = "admin/push-notification/details/update"

export const SEND_NOTIFICATION = "admin/push-notification/broadcast"
export const GET_NOTIFICATION_HISTORY =
  "admin/push-notification/messages/history"
export const DELETE_SCHEDULE_NOTIFICATION =
  "admin/push-notification/messages/delete"
export const SEARCH_CUSTOMERS_BY_PHONE = "admin/push-notification/search-customers-by-phone"

// CUSTOMER SUPPORT
export const GET_ALL_ISSUE_TYPE = "admin/support/issue-type/all"
export const UPDATE_ISSUE_TYPE_STATUS =
  "admin/support/issue-type/details/update-status"
export const DELETE_ISSUE_TYPE = "admin/support/issue-type/delete"
export const ADD_ISSUE_TYPE = "admin/support/issue-type/add"
export const GET_ISSUE_TYPE_DETAILS = "admin/support/issue-type/details"
export const UPDATE_ISSUE_TYPE_DETAILS =
  "admin/support/issue-type/details/update"
export const ISSUE_TYPE_DROPDOWN_LISTS = "admin/support/issue-type/list"

export const GET_ALL_SUPPORT_TICKET = "admin/support/tickets/all"
export const GET_TICKET_DETAILS = "admin/support/tickets/details"
export const UPDATE_TICKET_STATUS =
  "admin/support/tickets/details/update-status"
export const UPDATE_BULK_TICKET_STATUS =
  "admin/support/tickets/details/update-multiple-status"

// INGREDIENT
export const GET_ALL_INGREDIENTS_LIST = "admin/ingredient/list"
export const GET_ALL_INGREDIENTS = "admin/ingredient/all"
export const UPDATE_INGREDIENT_STATUS = "admin/ingredient/details/update-status"
export const GET_INGREDIENT_DETAILS = "admin/ingredient/details"
export const DELETE_INGREDIENT = "admin/ingredient/delete"
export const ADD_INGREDIENT = "admin/ingredient/add"
export const UPDATE_INGREDIENT = "admin/ingredient/details/update"
// ALLERGEN
export const GET_ALL_ALLERGENS_LIST = "admin/allergen/list"
export const GET_ALL_ALLERGEN = "admin/allergen/all"
export const GET_ALLERGEN_DETAILS = "admin/allergen/details"
export const UPDATE_ALLERGEN_STATUS = "admin/allergen/details/update-status"
export const DELETE_ALLERGEN = "admin/allergen/delete"
export const ADD_ALLERGEN = "admin/allergen/add"
export const UPDATE_ALLERGEN = "admin/allergen/details/update"

// REPORTS
export const GET_ALL_SALES_REPORTS = "admin/reports/sales"
export const GET_PAYMENTS_METHOD_REPORTS = "admin/reports/payment-methods"
export const GET_BUSINESS_TAX_REPORTS = "admin/reports/business-tax"
export const GET_LOYALTY_POINTS_REPORTS = "admin/reports/loyalty-points"
export const GET_WALLET_REPORT = "admin/reports/wallet-report"

// FAQ
export const GET_ALL_FAQ = "admin/page-content/all"
export const ADD_FAQ = "admin/page-content/add"
export const GET_FAQ_DETAILS = "admin/page-content/details"
export const UPDATE_FAQ = "admin/page-content/details/update"
export const DELETE_FAQ = "admin/page-content/delete"
export const UPDATE_FAQ_STATUS = "admin/page-content/details/update-status"
export const GET_PAGE_CONTENT_BY_TYPE = "admin/page-content/get-by-type"
export const UPDATE_PAGE_CONTENT_BY_TYPE = "admin/page-content/update-by-type"

// BOOKINGS
export const GET_ALL_BOOKINGS = "admin/booking/all"
export const GET_BOOKING_DETAILS = "admin/booking/details"
export const DELETE_BOOKING = "admin/booking/delete"
export const UPDATE_BOOKING_STATUS = "admin/booking/details/update-status"

// QR CODE
export const QR_CODE_GENERATE = "admin/common/dynamiclink/create"
export const SAVE_DYNAMIC_LINK = "admin/common/dynamiclink/save"

// EXPORT REQUEST
export const EXPORT_REQUEST = "admin/common/export-requests"

// PUBLIC
export const PUBLIC_PRIVACY_POLICY = "admin/page-content/public/PrivacyPolicy"
export const PUBLIC_TERMS_CONDITIONS =
  "admin/page-content/public/TermsAndConditions"

// VEHICLE
export const GET_ALL_VEHICLES = "admin/vehicles/all"
export const ADD_VEHICLE = "admin/vehicles/Add"
export const UPDATE_VEHICLE = "admin/vehicles/details/update"
export const GET_VEHICLE_DETAILS = "admin/vehicles/details"
export const UPDATE_VEHICLE_STATUS = "admin/vehicles/details/update-status"
export const DELETE_VEHICLE = "admin/vehicles/delete"
